<template>
  <tr>
    <td class="align-middle">{{ documentData.name }}</td>
    <td style="width: 200px;" class="align-middle">
      <d-button
        theme="primary"
        @click.native="downloadDocument"
        :disabled="downloadInProgress"
        class="mr-2"
        title="Edit">
        <i class="material-icons">cloud_download</i>
        Download file
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeDocument"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'document-downloads-list-item',
  props: {
    documentData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      downloadInProgress: false,
      removeInProgress: false
    };
  },
  methods: {
    removeDocument () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: 'countries/documents/delete/',
        id: parseInt(this.documentData.id, 10),
        successTitle: 'Document removed',
        successText: 'The selected document has been removed',
        confirmTitle: 'Do you really want to remove this document?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('document-downloads-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    downloadDocument () {
      if (this.downloadInProgress) {
        return;
      }

      this.downloadInProgress = true;
      let url = '/countries/documents/download/' + parseInt(this.documentData.id, 10);

      this.$http.get(url, {
        responseType: 'blob'
      }).then((response) => {
        let link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        let filename = response.request.getResponseHeader('content-disposition').split('filename=')[1].split(';')[0];
        link.setAttribute('download', filename.replace(/"/gmi, ''));
        link.setAttribute('id', 'download-link');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadInProgress = false;
      }).catch((err) => {
        console.log(err);
        this.downloadInProgress = false;
      });
    }
  }
};
</script>
